import { createApp } from 'vue'
import FormInputNameField from './FormInputNameField'

const el = '.kb-component--form-input-name-field'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((FormInputNameFieldDOM) => {
            const props = {
                type: FormInputNameFieldDOM.dataset.type,
                tooltipText: FormInputNameFieldDOM.dataset.tooltiptext,
                errorMessageLabel:
                    FormInputNameFieldDOM.dataset.errormessagelabel,
                helpMessageLabel:
                    FormInputNameFieldDOM.dataset.helpmessagelabel,
                placeholder: FormInputNameFieldDOM.dataset.placeholder,
                label: FormInputNameFieldDOM.dataset.label,
                isRequired: !!(
                    FormInputNameFieldDOM.dataset.isrequired === 'true'
                ),
                fieldName: FormInputNameFieldDOM.dataset.fieldname
            }
            const component = createApp(FormInputNameField, props).use(Store)
            component.mount(FormInputNameFieldDOM)
        })
    }
}
